import React from "react";
import { Card, CardContent, Typography, Box, Input } from "@mui/joy";
import { AlertTriangle } from "lucide-react";

import { SettingField } from "./EstimatingCommon";

interface FeesAndIncidentalsProps {
    values: Record<string, any>;
    onChange: (key: string, value: any) => void;
}

export default function FeesAndIncidentals({ values, onChange }: FeesAndIncidentalsProps) {
    return (
        <Card variant="soft" sx={{ border: "1px solid", borderColor: "divider" }}>
            <CardContent>
                <Box sx={{ display: "flex", gap: 1, mb: 2, alignItems: "center" }}>
                    <Box sx={{ p: 0.75, borderRadius: "sm", bgcolor: "warning.softBg", color: "warning.solidBg" }}>
                        <AlertTriangle size={18} />
                    </Box>
                    <Box>
                        <Typography
                            level="body-xs"
                            color="primary"
                            sx={{ textTransform: "uppercase", letterSpacing: "0.05em", fontWeight: "lg" }}
                        >
                            Logistical Fees
                        </Typography>
                    </Box>
                </Box>

                <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
                    <SettingField label="Permit Cost">
                        <Input
                            size="sm"
                            startDecorator="$"
                            value={values.EST_PERMIT_COST}
                            onChange={(e) => onChange("EST_PERMIT_COST", e.target.value)}
                            type="number"
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="Dumpster Fee">
                        <Input
                            size="sm"
                            startDecorator="$"
                            value={values.EST_DUMPSTER_FEE}
                            onChange={(e) => onChange("EST_DUMPSTER_FEE", e.target.value)}
                            type="number"
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="EagleView Report">
                        <Input
                            size="sm"
                            startDecorator="$"
                            value={values.EST_EAGLEVIEW_COST}
                            onChange={(e) => onChange("EST_EAGLEVIEW_COST", e.target.value)}
                            type="number"
                            sx={{ width: 100 }}
                        />
                    </SettingField>

                    <SettingField label="Job photos">
                        <Input
                            size="sm"
                            startDecorator="$"
                            value={values.EST_JOB_PHOTOS_FEE}
                            onChange={(e) => onChange("EST_JOB_PHOTOS_FEE", e.target.value)}
                            type="number"
                            sx={{ width: 100 }}
                        />
                    </SettingField>
                </Box>
            </CardContent>
        </Card>
    );
}
